import { isDisplayFieldType } from "../formBuilder/apiFieldTypes";
import { fieldFromDto } from "../formBuilder/draft";
import { formatSubmissionValue } from "./formatSubmissionValue";
import { resolveFieldType } from "./normalizeFieldType";
import { isFieldVisible, normalizeValue } from "./visibility";
import type { FieldDto } from "../../types/field";
import type { ValuesByName } from "../../types/visibility";

/** Текст вопроса бота. Для display/privacy вопрос — сам виджет. */
export function chatbotAnswerText(
  field: FieldDto,
  raw: unknown,
  cityNames?: Record<string, string>,
): string {
  if (resolveFieldType(field.type) === "privacy") {
    return normalizeValue(raw) === "1" ? "Согласие" : "—";
  }
  return formatSubmissionValue(fieldFromDto(field, 0), raw, { cityNames });
}

export function chatbotQuestion(field: FieldDto): string | null {
  const type = resolveFieldType(field.type);
  if (type === "display" || type === "privacy") return null;
  const label = (field.label ?? "").trim();
  return label || field.name;
}

/** Поля, которым нужна площадь ленты, а не узкая строка ввода. */
export function isChatbotWidgetField(type: string | null | undefined): boolean {
  const resolved = resolveFieldType(type);
  return (
    resolved === "display" ||
    resolved === "privacy" ||
    resolved === "select" ||
    resolved === "choice" ||
    resolved === "multiple-choice"
  );
}

export function initialChatHistory(
  fields: FieldDto[],
  values: ValuesByName,
): string[] {
  const history: string[] = [];

  for (let index = 0; index < fields.length; index += 1) {
    const field = fields[index]!;
    if (!isFieldVisible(field, values)) continue;

    if (isDisplayFieldType(field.type)) {
      const laterAnswered = fields.slice(index + 1).some(
        (next) =>
          !isDisplayFieldType(next.type) &&
          isFieldVisible(next, values) &&
          normalizeValue(values[next.name]) !== "",
      );
      if (laterAnswered) {
        history.push(field.name);
        continue;
      }
      break;
    }

    if (normalizeValue(values[field.name]) !== "") {
      history.push(field.name);
      continue;
    }

    break;
  }

  return history;
}

/** Обрезать историю до выбранного ответа, значения полей не трогать. */
export function historyBeforeField(history: string[], name: string): string[] {
  const index = history.indexOf(name);
  if (index < 0) return history;
  return history.slice(0, index);
}

export function nextChatField(
  fields: FieldDto[],
  values: ValuesByName,
  history: Iterable<string>,
): FieldDto | null {
  const done = new Set(history);
  for (const field of fields) {
    if (!isFieldVisible(field, values)) continue;
    if (done.has(field.name)) continue;
    return field;
  }
  return null;
}
